import _ from 'lodash'
import { Level } from '@qure/containers'
import React from 'react'
import PropTypes from 'prop-types'
import UserSettingsDropdown from './UserSettingsDropdown'
import backendChecks from '../../../libs/backendChecks'

const UserSettings = props => {
  const { userProfile, onLogout, t } = props

  const userName = _.get(userProfile, ['user', 'username'])
  const trimmedUserName = _.truncate(userName, { length: 14 })
  let userRole = backendChecks.getUserRoles(userProfile)
  userRole = userRole.map(role => t(role))
  const roles =
    _.size(userRole) === 3 ? t('Program manager') : userRole.join('-')
  return (
    <div className="user-settings">
      <Level>
        <div>
          <div className="is-uppercase has-text-weight-bold" title={userName}>
            {trimmedUserName}
          </div>
          <div className="is-uppercase user-role-wrapper" title={roles}>
            {_.truncate(roles, { length: 15 })}
          </div>
        </div>
        <UserSettingsDropdown
          onLogout={onLogout}
          t={t}
          userProfile={userProfile}
        />
      </Level>
    </div>
  )
}

UserSettings.defaultProps = {
  userProfile: null
}

UserSettings.propTypes = {
  userProfile: PropTypes.shape({
    user: PropTypes.shape({
      user: PropTypes.string,
      roles: PropTypes.arrayOf(PropTypes.string)
    })
  }),
  onLogout: PropTypes.func.isRequired,
  t: PropTypes.func.isRequired
}

export default UserSettings
